import { render, staticRenderFns } from "./form-areaArea.vue?vue&type=template&id=2d8df652&"
import script from "./form-areaArea.vue?vue&type=script&lang=js&"
export * from "./form-areaArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports